import { TextCodes } from '@api/types/translation/TextCodes';
import { Html, ProductDetailsContext, ProductSection } from '@components';
import { BannerBlock } from '@components/blocks/content/BannerBlock/BannerBlock';
import { ContentListBlock } from '@components/blocks/content/ContentListBlock/ContentListBlock';
import { TeaserBlock } from '@components/blocks/content/TeaserBlock/TeaserBlock';
import { Box, Stack, styled } from '@mui/material';
import { t } from '@translations';
import { useContext } from 'react';

const DescriptionBox = styled(Box)`
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.01em;
  color: #3a454a;
`;

export const ProductLongDescription = () => {
  const { product = {}, sections, onSectionEnter } = useContext(ProductDetailsContext);
  const { productLongDescription = '' } = product;
  const description = productLongDescription.replace('\n', '<br /><br />');

  return sections?.description ? (
    <ProductSection
      sectionId='description'
      title={t(TextCodes.Product.Details.Description)}
      onSectionEnter={onSectionEnter}
    >
      <Stack spacing={4}>
        <DescriptionBox>
          <Html html={description} />
        </DescriptionBox>
        {product.banners?.map((banner) => (
          <BannerBlock {...banner.expanded} key={banner.guidValue} />
        ))}
        {product.teasers?.map((teaser) => (
          <TeaserBlock {...teaser.expanded} key={teaser.guidValue} />
        ))}
        {product.contentLists?.map((contentList) => (
          <ContentListBlock {...contentList.expanded} key={contentList.guidValue} />
        ))}
      </Stack>
    </ProductSection>
  ) : null;
};
